import { render, staticRenderFns } from "./buy-vps-server-process.html.vue?vue&type=template&id=65a08bca"
import script from "./buy-vps-server-process.html.vue?vue&type=script&lang=js"
export * from "./buy-vps-server-process.html.vue?vue&type=script&lang=js"
import style0 from "./buy-vps-server-process.html.vue?vue&type=style&index=0&id=65a08bca&prod&lang=scss"
import style1 from "./buy-vps-server-process.html.vue?vue&type=style&index=1&id=65a08bca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports